
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[channelPath]",
      function () {
        return require("private-next-pages/[channelPath]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[channelPath]"])
      });
    }
  